import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useMutation } from "@apollo/client";
import { News, UserContentType } from "@onmo/graphql/graphql";
import { startContentViewGQL } from "../../../graphql";
import { GamingStorage } from "../../../models/gamingStorage";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { Image } from "../../core/Image/Image";
import { Time } from "../../../models/time";
import { decodeHtmlEntities } from "../../../models/htmlEntities";
import { useStyles } from "./NewsCard.style";

interface INewsCardProps {
  news: News;
}

export const NewsCard: FC<INewsCardProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { news, className, ...otherProps } = props;
  const [startContentView] = useMutation(startContentViewGQL);

  const onNewsRedirect = async () => {
    if (!news?.url) return;

    try {
      const contentView = await startContentView({
        variables: { input: { contentType: UserContentType.Article } },
      });
      const contentId = contentView?.data?.startContentView?.contentId;
      if (contentId) GamingStorage.setPendingArticleView(contentId);
    } catch {
      //do nothing
    }

    window.open(news?.url, "_self");
  };

  return (
    <div
      {...otherProps}
      className={clsx(classes.root, className)}
      onClick={onNewsRedirect}
    >
      <div className={classes.content}>
        <div>
          <Typography
            variant={TypographyVariant.BodyB5Medium}
            color={TypographyColor.Silver}
            className={classes.source}
          >
            {decodeHtmlEntities(news?.source)}
          </Typography>
          <Typography variant={TypographyVariant.BodyB4Medium}>
            {decodeHtmlEntities(news?.title)}
          </Typography>
        </div>
        {news?.image && <Image url={news?.image} className={classes.newsImg} />}
      </div>
      <div className={classes.bottomTime}>
        <Typography
          variant={TypographyVariant.BodyB6Medium}
          color={TypographyColor.Silver}
        >
          {decodeHtmlEntities(news?.category)}
        </Typography>
        <ul className={classes.time}>
          <li>
            <Typography
              variant={TypographyVariant.BodyB6Medium}
              color={TypographyColor.Silver}
            >
              {Time.getTimeAgo(news?.publishedDate)}
            </Typography>
          </li>
        </ul>
      </div>
    </div>
  );
};
